import { createContext } from "react";

export type EnergyUnitPrefix = "" | "k";

/**
 * Context for forcing energy/power unit display in PropAI.
 *
 * Mirrors the CurrencyFormatContext pattern: apps provide this at the root
 * (reading the `preferences.PropAIenergyprefix` branding preference), and
 * shared components like InfoCard / Last5YearsChart / BaseTimeSeriesChart
 * read from it to decide whether to skip auto-scaling (kWh → MWh/GWh, kW → MW/GW).
 *
 * - `""` (default, absent context) → normal unit logic.
 * - `"k"` → always render energy as `kWh` and power as `kW`, no matter the size.
 *
 * Components also accept an optional `energyUnitPrefix` prop which overrides the context.
 */
export const EnergyUnitPrefixContext = createContext<EnergyUnitPrefix | undefined>(undefined);
